import React from 'react';
import { Icon } from '../../../../utilities/icomoon-css';
import { AutoPayTypes } from '../../AutoPayTypes';
import {
  autoPayPageLabels,
  LargeIconSize,
  MediumIconSize,
} from '../../constants/accountPanelConfigs';

export const AutoPayLayout = ({ children }: AutoPayTypes.TAutoPayLayout) => {
  const { mainTitle } = autoPayPageLabels;
  return (
    <div className="autoPayParentContainer">
      <div className="autoPayContentContainer">
        <div className="iconContainer">
          <div className="syncIcon">
            <Icon name="tfw-refresh-2-cp" size={LargeIconSize} color="black" />
          </div>
          <div className="dollarIcon">
            <Icon
              name="tfw-dollar-circle-cp"
              size={MediumIconSize}
              color="black"
            />
          </div>
        </div>
        <div className="autoPayTitle">
          <h5>{mainTitle}</h5>
        </div>
        {children}
      </div>
    </div>
  );
};
